import * as types from '../mutation-types'
import { getTrendingItems, getSuggestionItems } from '@/store/api/order'

const state = {
  trends: [],
  suggestions: [],
  loading: false
}

const getters = {
  trendingItemDescriptions: (state) => state.trends,
  suggestionItemDescriptions: (state) => state.suggestions,
  loadingSuggestionItemDescriptions: (state) => state.loading
}

const mutations = {
  [types.SET_TRENDING_ITEM_DESCRIPTIONS](state, data = []) {
    state.trends =
      data && data.length > 0
        ? data.map((item) => ({
            code: item.code,
            keyword: item.keyword,
            group: item.group
          }))
        : []
  },
  [types.SET_SUGGESTION_ITEM_DESCRIPTIONS](state, data = []) {
    state.suggestions = data.map((item) => ({
      code: item.code,
      keyword: item.keyword,
      group: item.group
    }))
  },
  [types.SET_LOADING_SUGGESTIONS](state, loading) {
    state.loading = loading
  }
}

const actions = {
  getTrendingItems({ commit }, params) {
    return new Promise((resolve, reject) => {
      getTrendingItems(params)
        .then((data) => {
          commit(types.SET_TRENDING_ITEM_DESCRIPTIONS, data)
          resolve()
        })
        .catch((e) => {
          console.error(e)
          reject()
        })
    })
  },
  getSuggestionItems({ commit }, params) {
    commit(types.SET_LOADING_SUGGESTIONS, true)
    return new Promise((resolve, reject) => {
      getSuggestionItems(params)
        .then((data) => {
          commit(types.SET_SUGGESTION_ITEM_DESCRIPTIONS, data)
          resolve()
        })
        .catch((e) => {
          console.error(e)
          reject()
        })
        .finally(() => {
          commit(types.SET_LOADING_SUGGESTIONS, false)
        })
    })
  }
}

const itemDescription = {
  state,
  getters,
  mutations,
  actions
}

export default itemDescription
